<!-- SiteFooter.vue - no links any more: Impressum, Datenschutz, Barrierefreiheit and Für Kommunen live in the
     "Mehr" sheet of the bottom nav (MoreSheet.vue), two taps from every screen.
     This element only keeps the room under the floating nav. The landing page ends with the hill
     illustration and lets the nav float over it, so it gets no room. -->
<template>
  <div v-if="$route.name !== 'LandingPage'" class="nav-room" aria-hidden="true"></div>
</template>

<script>
export default { name: 'SiteFooter' };
</script>

<style scoped>
.nav-room { height: calc(104px + env(safe-area-inset-bottom, 0px)); }
</style>
